import React from "react";
import {
  Box,
  Typography,
  Container,
  Paper,
  Divider,
  CssBaseline,
  useTheme,
} from "@mui/material";

const PrivacyPolicy = () => {
  const theme = useTheme();

  return (
    <>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ mt: 9, mb: 4 }}>
        <Paper
          elevation={3}
          sx={{ p: { xs: 3, md: 4 }, backgroundColor: theme.palette.background.paper }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 700
            }} color={theme.palette.primary.main}
          >
            Privacy Policy - Arthgyan.com
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Box mt={2}>
            {/* <Typography
              variant="h8"
              gutterBottom
              // sx={{ fontSize: "1.2rem" }}
              color={theme.palette.text.primary}
            >
              Privacy Policy:
            </Typography> */}
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              Date of last revision: January 22, 2025
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              By signing up for the Services, or providing us with your personal information for any other purpose, you agree to the terms of this Privacy Policy. This policy will help you understand the types of information we collect, the purpose for which it is collected, how it is used, and how it is protected. "Personal information" means any information that can identify you personally.
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box mt={2}>
            <Typography
              variant="h8"
              fontWeight="bold"
              gutterBottom
              // sx={{ fontSize: { xs: "16px", md: "18px" }, fontWeight: 700 }}
              color={theme.palette.text.primary}
            >
              HOW WE COLLECT AND USE YOUR PERSONAL INFORMATION
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              Pre-registration - You cannot access any section or features of ArthGyan without registering or disclosing personal information. We capture anonymous visitor data such as usage patterns to understand and improve the app.
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              Registration - To access the app, you need to create a Username and Password (“Login Credentials”).
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              Investment - To use investment services, you may need to provide:
            </Typography>
            <ul style={{ color: theme.palette.text.primary }}>
              <li>Contact details (name, age, email, etc.)</li>
              <li>Demographic data (address, pin code, etc.)</li>
              <li>Bank account details for investments</li>
              <li>Documents under KYC norms</li>
            </ul>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box mt={2}>
            <Typography
              variant="h8"
              fontWeight="bold"
              gutterBottom
              // sx={{ fontSize: "1.2rem" }}
              color={theme.palette.text.primary}
            >
              SHARING YOUR PERSONAL INFORMATION
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              We never sell or rent your personal information. Access is restricted and governed by law. Third-party vendors may assist us, but are contractually obligated to maintain confidentiality.
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              Disclosure may occur only when required by law. We use your information with prior consent to provide relevant services.
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box mt={2}>
            <Typography
              variant="h8"
              fontWeight="bold"
              gutterBottom
              // sx={{ fontSize: "1.2rem" }}
              color={theme.palette.text.primary}
            >
              INFORMATION STORAGE AND SECURITY
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              We implement multiple security measures (firewalls, encryption, SSL) to safeguard your data. However, no system is 100% secure. You are responsible for protecting your login credentials. We provide assistance in case of breaches.
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box mt={2}>
            <Typography
              variant="h8"
              fontWeight="bold"
              gutterBottom
              // sx={{ fontSize: "1.2rem" }}
              color={theme.palette.text.primary}
            >
              ACCESS AND UPDATE
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              You have the right to access, correct, and delete your personal information as per the Digital Personal Data Protection Act, 2023.
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box mt={2}>
            <Typography
              variant="h8"
              fontWeight="bold"
              gutterBottom
              // sx={{ fontSize: "1.2rem" }}
              color={theme.palette.text.primary}
            >
              CONTACT INFORMATION
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              Email: pthakur@arthgyan.com
            </Typography>
            <Typography
              variant="body2"
              paragraph
              // sx={{ fontSize: "0.875rem" }}
              color={theme.palette.text.primary}
            >
              Address: Plot No C-9, Asha Officers Colony, R K Puram, Hyderabad - 500056
            </Typography>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
